import { render, staticRenderFns } from "./AssignRider.vue?vue&type=template&id=0ccf9f6e&"
import script from "./AssignRider.vue?vue&type=script&lang=js&"
export * from "./AssignRider.vue?vue&type=script&lang=js&"
import style0 from "./AssignRider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports